import { system } from 'styled-system';

export const gutter = system({
  $gutter: {
    property: 'marginLeft',
    scale: 'space',
  },
});

export const columnWidth = system({
  width: {
    property: 'width',
    scale: 'layout',
  },
});
